import React from "react";
import { connect } from "react-redux";
import { styled } from "@acko-tech/building-blocks.ui.common";

import ImageContainer from "@components/imageContainer";
import { CommonProps } from "@utils/interface";
import { getWidgetSpecificIsVisible } from "@utils/index";

const mapStateToProps = function (state: any, ownProps: any) {
  const isVisibleFromProps = ownProps.is_visible;
  const isVisibleFromRedux = ownProps.id 
    ? getWidgetSpecificIsVisible(
        state.configuration?.normalisedConfig,
        ownProps.id
      )
    : undefined;
  
  return {
    is_visible: isVisibleFromProps !== undefined ? isVisibleFromProps : isVisibleFromRedux
  };
};

export const BadgeContainer = styled.div`
  border-radius: 20px;
  padding: 4px 12px;
  width: max-content;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  background: ${(props) => {
    switch (props.type) {
      case "PREMIUM":
        return "#fbe9f6";
      case "DANGER":
        return "#FBEAEA";
      case "GENERIC":
        return "#F0F0F6";
      case "WARNING":
        return "#FFD5B4";
      case "CURRENT":
        return "linear-gradient(93deg, #DE6C32 2.2%, #E157CF 97.8%)";
      default:
        return "#F0F0F6";
    }
  }};
  ${(props) => props.styles};
`;

export const BadgeText = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0px;

  ${(props) => {
    switch (props.type) {
      case "PREMIUM":
        return `
        background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
        background-clip: text;
        text-fill-color: transparent;
        -webkit-text-fill-color: transparent;
        font-weight: 600;
      `;
      case "DANGER":
        return `
        color: #D83D37;
      `;
      case "GENERIC":
        return `
        color: #5B5675;
      `;
      case "CURRENT":
        return `
        color: white;
        font-weight: 600;
      `;
      case "WARNING":
        return `
        background: linear-gradient(269deg, #88613A -10.35%, #E4833D 106.34%);
        background-clip: text;
        text-fill-color: transparent;
        -webkit-text-fill-color: transparent;
        font-weight: 600;
      `;
      default:
        return `
        color: #5B5675;
        `;
    }
  }}

  ${(props) => props.textstyle};
`;

export interface IBadge extends CommonProps {
  type?: "PREMIUM" | "DANGER" | "GENERIC";
  image?: any;
  text: string;
  styles?: any;
  textStyles?: any;
}

const Badge = (props: IBadge) => {
  const { type, image, text, styles, is_visible, id, textStyles } = props;
  const { imgSrc, width = 16, height = 16, alt } = image || {};

  if(is_visible == false) return <></>;
  return (id && is_visible) || !id ? (
    <BadgeContainer type={type} styles={styles}>
      <ImageContainer imgSrc={image} width={width} height={height} alt={alt} />
      <BadgeText textstyle={textStyles} type={type}>{text}</BadgeText>
    </BadgeContainer>
  ) : null;
};

export default connect(mapStateToProps)(Badge);
